import heroPage from 'components/hero-page/hero-page';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import blockCategories from 'components/flexible-contents/block-categories/index';
import blockProducts from 'components/flexible-contents/block-products/index';
import blockTextColumn from 'components/flexible-contents/block-text-column/index';
import blockImageText from 'components/flexible-contents/block-image-text/index';
import blockGridCardsIcons from 'components/flexible-contents/block-grid-cards-icons/index';
import blockFaqContact from 'components/flexible-contents/block-faq-contact/index';
import blockIframe from 'components/flexible-contents/block-iframe/index';
import blockSliderPosts from 'components/flexible-contents/block-slider-posts/index';
import blockSliderBrands from 'components/flexible-contents/block-slider-brands/index';
import blockCtaOrNewsletter from 'components/flexible-contents/block-cta-or-newsletter/index';
import blockSliderReviews from 'components/flexible-contents/block-slider-reviews/index';

import './single-post.scss';

heroPage();
breadcrumbs();
blockCategories();
blockProducts();
blockTextColumn();
blockImageText();
blockGridCardsIcons();
blockFaqContact();
blockIframe();
blockSliderPosts();
blockSliderBrands();
blockCtaOrNewsletter();
blockSliderReviews();

